import React from "react";
var __jsx = React.createElement;
import stl from "./CitiesList.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var CitiesList = function CitiesList(_ref) {
  var cities = _ref.cities;
  var _useTranslation = useTranslation(["web_city"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CL_container
  }, /*#__PURE__*/React.createElement("h1", null, t("اشتري سيارتك من سيارة إلى كافة المحافظات السعودية", {
    ns: "web_city"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.CL_list
  }, Object.values(cities).map(function (city, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: createUrl("/city/".concat(city.seo_name))
    }, /*#__PURE__*/React.createElement("h2", null, city.name));
  }))));
};
export default CitiesList;